import React, { useContext } from "react";
var AccordionItemContext = /*#__PURE__*/React.createContext();
export var AccordionItemProvider = AccordionItemContext.Provider;

function useAccordionItem() {
  var accordionItemInfo = useContext(AccordionItemContext);

  var _ref = accordionItemInfo !== null && accordionItemInfo !== void 0 ? accordionItemInfo : {
    headerId: null,
    contentId: null,
    isOpen: false,
    toggleAccordionItem: function toggleAccordionItem() {}
  },
      headerId = _ref.headerId,
      contentId = _ref.contentId,
      isOpen = _ref.isOpen,
      toggleAccordionItem = _ref.toggleAccordionItem;

  return {
    headerId: headerId,
    contentId: contentId,
    isOpen: isOpen,
    toggleAccordionItem: toggleAccordionItem
  };
}

export default useAccordionItem;